<template>
  <div class="p-grid">
    <div class="p-col-12">
      <div class="card card-w-title">
        <div class="manager-title">{{ title }}</div>
        <BaseDatatable
          :key="componentKey"
          :tableData="listData"
          :model="dataModel"
          :getFilterOptions="getFilterOptions"
          :actions="getRowActions()"
          @filter_date_single = "onFilterDateSingle"
          @filter_date = "onFilterDate"
          v-on:action-click="onActionClicked"
        ></BaseDatatable>
        <!-- <Popup
          :key="editDialogKey"
          :show="displayDialog"
          :objKey="editId"
          :objModelName="modelName"
          :mode="dialogMode"
          @onChange="onChange()"
        ></Popup> -->

        <Dialog
          header="Xóa"
          :visible.sync="showDeleteDialog"
          :contentStyle="{overflow: 'visible'}"
          :modal="true"
        >
          Bạn có chắc muốn xóa <strong>{{this.deleteName}}</strong>
          <template
            #footer
          >
            <Button label="Xóa" @click="deleteData()" icon="pi pi-check" class="p-button-danger" />
            <Button
              label="Hủy"
              @click="showDeleteDialog = false"
              icon="pi pi-times"
              class="p-button-warning"
            />
          </template>
        </Dialog>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import DataServices from '@/core/DataServices'
import BaseDatatable from './list'
import store from '@/store'
// import Popup from './popup'
export default {
  components: {
    BaseDatatable,
    // Popup
  },
  data() {
    return {
      filters: {},
      filterOptions: {},
      listData: [],
      listDataFull: [],
      modelName: '',
      dataModel: null,
      title: '',
      componentKey: 0,
      editId: null,
      displayDialog: false,
      editDialogKey: 0,
      dialogMode: 'edit',
      deleteId: null,
      deleteName: null,
      showDeleteDialog: false
    }
  },
  beforeCreate() {
    if (store.getters.group_permission && store.getters.group_permission.list_organization.list == false && store.getters.role != "admin") {
      this.$router.push({name: '404'})
    }
  },
  created() {
    this.modelName = this.$route.meta.model;
    this.dataModel = DataServices.getModel(this.modelName)
    this.title = this.dataModel.name
    this.$store.commit('setLoading', true);
    if(this.$route.params.reload) {
     // window.location.reload();
    }
  },
  watch: {
    '$route': 'initParams'
  },
  methods: {
    initParams() {
      this.$store.commit('setLoading', true);
      this.modelName = this.$route.meta.model;
      this.dataModel = DataServices.getModel(this.modelName);
      this.title = this.dataModel.label;
    },
    onFilterDateSingle(data) {
      let date = data.data;
      let list = []
      if (date[0] !== null) {
        let day_off_from = moment(date[0]).utc().format(data.format)
        for (let i = 0; i < this.listData.length; i++) {
          const e = this.listData[i];
          if (e.date_off == day_off_from) {
            list.push(e)
          }
        }
        this.listData = list
      }
      this.componentKey++;
    },
    onFilterDate(data) {
      let date = data.data;
      let list = []
      if (date[0] !== null && date[1] !== null) {
        this.listData = this.listDataFull
        let day_off_from = moment(date[0]).utc().format(data.format)
        let day_off_to = moment(date[1]).add(1, 'days').utc().format(data.format)
        console.log('this.listData', this.listData)
        for (let i = 0; i < this.listData.length; i++) {
          const e = this.listData[i];
          console.log('date off', moment(e.date_off).utc().format(data.format))
          if (moment(e.date_off).utc().format(data.format) >= day_off_from && moment(e.date_off).utc().format(data.format) <= day_off_to) {
            list.push(e)
          }
        }
        this.listData = list
      }
      this.componentKey++;
    },
    onChange() {
      this.$store.commit('setLoading', true);
      this.$apollo.queries.listData.refresh()
    },
    getFilterOptions(name) {
      var field = this.dataModel.getField(name)
      var result = []
      if (field.type == 'Selection') {
        result = field.options;
      } else {
        result = this.filterOptions[name] != null ? [...this.filterOptions[name]] : []
      }
      return result;
    },
    getRowActions() {
      var actions = {}
      var that = this;
      if ((store.getters.group_permission && store.getters.group_permission.list_organization.add == true) || store.getters.role == "admin") {
      actions.header = { name: 'add', icon: 'plus', path: `list-${this.modelName}/add`};
      }
      // actions.header = { name: 'add', icon: 'plus'};
      actions.rows = function (rowData) {
        var buttons = {}
        // buttons.view = { name: 'view', icon: 'eye', key: 'id', path: `list-${that.modelName}/view/`};
        if ((store.getters.group_permission && store.getters.group_permission.list_organization.edit == true) || store.getters.role == "admin") {
        buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `list-${that.modelName}/edit/`}
        }
        // buttons.edit = { name: 'edit', icon: 'pencil', key: 'id', path: `${that.modelName}/edit/`}
        if ((store.getters.group_permission && store.getters.group_permission.list_organization.delete == true) || store.getters.role == "admin") {
        buttons.delete = { name: 'delete', icon: 'trash', key: 'id'}
        }
        if (that.dataModel.actions) {
          var modelaction = that.dataModel.actions(rowData)
          Object.assign(buttons, modelaction);
        }
        return buttons
      }
      return actions
    },
    async onActionClicked(payload) {
      var action = payload.action
      var data = null
      if (payload.data) {
        data = payload.data
      }
      switch (action.name) {
        case 'view':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'edit':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path + data.data[action.key] })
          } else  {
            this.editId = data.data[action.key]
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'delete':
          this.deleteId = data.data[action.key]
          this.deleteName = data.data.name
          this.showDeleteDialog = true
          break
        case 'add':
          this.dialogMode = action.name
          if (action.path !== undefined && action.path) {
            this.$router.push({ path: action.path })
          } else  {
            this.displayDialog = true
            this.editDialogKey++
          }
          break
        case 'custom':
          await action.handler(data.data, this)
          this.componentKey++
          break
      }
    },
    async deleteData() {
      this.showDeleteDialog = false
      /*var query = DataServices.deleteData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        }
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(res => {
        console.log(res)
        // if (res.data.affected_rows > 0) {
          this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        // } else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      })*/
      var that = this;
      var where_office_agency = {id: {_eq: this.deleteId}};
      var obj_office_agency = await this.$CoreService.getObjectData('office_agency', where_office_agency);
      if (!obj_office_agency) {
        that.$toast.add({ severity: 'error', summary: 'Thông báo', detail: that.$constants.MSG_TEXT.ERR_PLEASE_TRY_AGAIN, life: 3000 })
        that.showDeleteDialog = false;
        return false;
      }
      var code = obj_office_agency.code;

      //kiểm tra Mã cơ quan này có tồn tại trong VB không
      var where_document = {code_agency: {_eq: code},deleted: {_eq: false}};
      var obj_document = await this.$CoreService.getObjectData('document', where_document);
      if (obj_document){
        //Nếu tồn tại KV trong VB thì ko dc xóa
        that.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cơ quan đang tồn tại trong VB. Bạn không thể xóa.', life: 3000 })
        that.showDeleteDialog = false;
        return false;
      }
      //Kiểm tra Cơ quan này có tồn tại trong Bảng giá cơ quan
      var where_organ_pricelist = {office_agency_id: {_eq: this.deleteId}};
      var obj_organ_pricelist = await this.$CoreService.getObjectData('organ_pricelist', where_organ_pricelist);
      if (obj_organ_pricelist){
        //Nếu tồn tại VP trong Cài đặt bảng giá cơ quan thì ko dc xóa
        that.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Cơ quan đang tồn tại trong Bảng giá cơ quan. Bạn không thể xóa.', life: 3000 })
        that.showDeleteDialog = false;
        return false;
      }

      var query = DataServices.updateData(this.modelName)
      var variables = {
        where_key: {
          id: {'_eq': this.deleteId}
        },
        'data_update': {
          'deleted': true
        },
      }
      this.$apollo.mutate({
        mutation: query,
        variables: variables
      }).then(() => {
        //if (res.data.delete_document.affected_rows > 0) {
        this.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Xóa dữ liệu thành công', life: 3000 })
        //} else this.$toast.add({ severity: 'error', summary: 'Thất bại', detail: 'Xóa dữ liệu thất bại', life: 3000 })
        this.$apollo.queries.listData.refresh()
      }).catch((error) => {
        this.$toast.add({ severity: 'error', summary: 'Thông báo', detail: 'Xóa dữ liệu gặp vấn đề', life: 3000 })
        console.error('ERROR: ', error)
      });
    }
  },
  apollo: {
    listData: {
      query() {
        this.modelName = this.$route.meta.model;
        return DataServices.getList(this.modelName);
      },
      variables: {
        where_key: {
          deleted: {_eq: false}
        }
      },
      update(data) {
        var listData = data[this.dataModel.tableName]
        this.listDataFull = listData
        this.title = this.dataModel.label + ' '
        this.dataModel.processData(listData)
        this.$store.commit('setLoading', false);
        this.componentKey += 1
        return data[this.dataModel.tableName]
      },
      fetchPolicy: 'network-only',
      error() {
        this.$store.commit('setLoading', false);
      },
      skip() {
        return !this.modelName
      }
    }
  }

}
</script>
<style lang="css">
.p-calendar .p-datepicker { width: 280px; padding: 0px; padding-top: 5px;}
.p-calendar .p-datepicker td, .p-calendar .p-datepicker td a {padding: 0px !important;}
.p-calendar .p-datepicker td span {padding: 0px !important; width: 30px !important; height: 30px !important;}
.p-datepicker .p-datepicker-header{padding: 5px !important;}
</style>